import { render } from "./app-icon-empty-product.vue?vue&type=template&id=f338fe84"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/icon/app-icon-empty-product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f338fe84"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f338fe84', __exports__)) {
    console.log('reload')
    api.reload('f338fe84', __exports__)
  }
  
  module.hot.accept("./app-icon-empty-product.vue?vue&type=template&id=f338fe84", () => {
    console.log('re-render')
    api.rerender('f338fe84', render)
  })

}


export default __exports__